export function generateSimpleID(): string {
    return '_' + Math.random().toString(36).substr(2, 9);
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/generate-simple-id.ts